import apiClient from '../services/apiClient'
import { Faq } from '../types/faq.type'

// Alias pour la compatibilité avec le code existant
export type FaqItem = Faq

// Fonctions d'API pour les FAQ
export const apiGetFaqs = async (category?: string, activeOnly: boolean = true): Promise<Faq[]> => {
    const params = new URLSearchParams()

    if (category) params.append('category', category)
    if (activeOnly) params.append('activeOnly', 'true')

    const queryString = params.toString()
    const url = queryString ? `/faq?${queryString}` : `/faq`
    const response = await apiClient.get<Faq[]>(url)
    return response.data
}

export const apiGetFaq = async (id: string): Promise<Faq> => {
    const response = await apiClient.get<Faq>(`/faq/${id}`)
    return response.data
}

export const apiCreateFaq = async (data: Omit<Faq, 'id' | 'createdAt' | 'updatedAt'>): Promise<Faq> => {
    const response = await apiClient.post<Faq>(`/faq`, data)
    return response.data
}

export const apiUpdateFaq = async (id: string, data: Partial<Faq>): Promise<Faq> => {
    const response = await apiClient.patch<Faq>(`/faq/${id}`, data)
    return response.data
}

export const apiDeleteFaq = async (id: string): Promise<void> => {
    await apiClient.delete(`/faq/${id}`)
}

export const apiGetFaqCategories = async (): Promise<string[]> => {
    const response = await apiClient.get<string[]>(`/faq/categories`)
    return response.data
}

// Alias pour la compatibilité avec le code existant
export const faqApi = {
    getAll: apiGetFaqs,
    getById: apiGetFaq,
    getCategories: apiGetFaqCategories,
    create: apiCreateFaq,
    update: apiUpdateFaq,
    delete: apiDeleteFaq,
}
